// =============================================================================
// trackerReducer.js
//
// Reducer puro: (state, action) → newState.
// Nunca muta o state — devolve sempre um novo objecto.
//
// State shape:
// {
//   entries:     [],    → lista de entradas na tabela
//   activeEntry: null,  → entrada aberta no modal (null = modo criar)
//   loading:     false, → true enquanto GET /GetAll corre
//   saving:      false, → true enquanto Create/Update/Delete correm
//   loadingOne:  false, → true enquanto GET /GetById corre
//   error:       null,  → string de erro ou null
//   modalOpen:   false, → visibilidade do modal
// }
// =============================================================================

import TRACKER from '../actions/trackerActionTypes';

const initialState = {
	entries:     [],
	activeEntry: null,
	loading:     false,
	saving:      false,
	loadingOne:  false,
	error:       null,
	modalOpen:   false,
};

const trackerReducer = (state = initialState, action) => {
	switch (action.type) {

					// ── Carregar lista ──────────────────────────────────────────────────────

					case TRACKER.FETCH_REQUEST:
						return { ...state, loading: true, error: null };

					case TRACKER.FETCH_SUCCESS:
						return { ...state, loading: false, entries: action.payload };

					case TRACKER.FETCH_FAILURE:
						return { ...state, loading: false, error: action.payload };

						// ── Carregar uma entrada ────────────────────────────────────────────────

					case TRACKER.FETCH_ONE_REQUEST:
						return { ...state, loadingOne: true, error: null };

					case TRACKER.FETCH_ONE_SUCCESS:
						// Abre o modal com a entrada completa
						return { ...state, loadingOne: false, activeEntry: action.payload, modalOpen: true };

					case TRACKER.FETCH_ONE_FAILURE:
						return { ...state, loadingOne: false, error: action.payload };

						// ── Criar ───────────────────────────────────────────────────────────────

					case TRACKER.CREATE_REQUEST:
						return { ...state, saving: true, error: null };

					case TRACKER.CREATE_SUCCESS:
						// Adiciona ao início da lista e fecha o modal
						return {
							...state,
							saving:      false,
							modalOpen:   false,
							activeEntry: null,
							entries:     [action.payload, ...state.entries],
						};

					case TRACKER.CREATE_FAILURE:
						return { ...state, saving: false, error: action.payload };

						// ── Actualizar ──────────────────────────────────────────────────────────

					case TRACKER.UPDATE_REQUEST:
						return { ...state, saving: true, error: null };

					case TRACKER.UPDATE_SUCCESS:
						// Substitui a entrada antiga pela actualizada e fecha o modal
						return {
							...state,
							saving:      false,
							modalOpen:   false,
							activeEntry: null,
							entries:     state.entries.map((e) =>
								e.id === action.payload.id ? action.payload : e
							),
						};

					case TRACKER.UPDATE_FAILURE:
						return { ...state, saving: false, error: action.payload };

						// ── Apagar ──────────────────────────────────────────────────────────────

					case TRACKER.DELETE_REQUEST:
						return { ...state, saving: true, error: null };

					case TRACKER.DELETE_SUCCESS:
						// Remove a entrada da lista e fecha o modal
						return {
							...state,
							saving:      false,
							modalOpen:   false,
							activeEntry: null,
							entries:     state.entries.filter((e) => e.id !== action.payload),
						};

					case TRACKER.DELETE_FAILURE:
						return { ...state, saving: false, error: action.payload };

						// ── Modal ───────────────────────────────────────────────────────────────

					case TRACKER.OPEN_MODAL:
						return { ...state, modalOpen: true, activeEntry: action.payload };

					case TRACKER.CLOSE_MODAL:
						return { ...state, modalOpen: false, activeEntry: null };

						// ── Erros ───────────────────────────────────────────────────────────────

					case TRACKER.CLEAR_ERROR:
						return { ...state, error: null };

						// ── Default ─────────────────────────────────────────────────────────────

					default:
						return state;
	}
};

export default trackerReducer;